<template>
  <div class="SalePayViewContainer">
    <nut-row class="pd16 box colFlex wd100">
      <div class="payTime colFlex bothCenter brd12 wd100">
        <nut-row class="bothCenter ft18">
          <img src="https://cdn.waityou.online/6a1a1b5d-7fa9-c0ff-817e-c79ffed631c1.png" class="sqr20">
          <span class="ml12">剩余支付时间</span>
        </nut-row>
        <nut-countdown class="mt12" v-model="resetTime" :endTime="end">
          <nut-row class="bothCenter">
            <div class="timePart bothCenter wft sqr26 brd4">
              {{ resetTime.m.toString().padStart(2, '0') }}
            </div>
            <span style="color: #EF773B">&nbsp;:&nbsp;</span>
            <div class="timePart bothCenter wft sqr26 brd4">
              {{ resetTime.s.toString().padStart(2, '0') }}
            </div>
            <span style="color: #EF773B">&nbsp;:&nbsp;</span>
            <div class="timePart bothCenter wft sqr26 brd4" style="width: 36px">
              {{ resetTime.ms }}
            </div>
          </nut-row>
        </nut-countdown>

        <div style="background: #F6C247" class="bothCenter vpd10 opd46 brd30 mt26">
          <span class="ft18 boldFont" @click="buyNow">继续支付</span>
        </div>
      </div>

      <div class="readMark bothCenter mt20 wd100">
        <span class="wft ft18 mb5">{{ detail.buyerShowName }}</span>
      </div>
      <div class="bookMarks brd12 box wd100 vpd16" v-if="detail.buyerRecommends"
           style="margin-top: -20px;padding-bottom: 200px;">
        <template v-for="(rc,rci) in detail.buyerRecommends" :key="`rc_${rci}`">
          <BookMark :data="rc"/>
        </template>
      </div>
    </nut-row>

    <nut-row class="wd100 wbg" style="position:fixed;bottom: 0;padding-bottom: 12px">
      <div style="background: #FCE4D8;width: 100%" class="vpd4 bothCenter">
        <nut-row class="bothCenter">
          <span class="ft12 numberText">仅剩{{ order.freeHeadCount }}个名额,请在&nbsp;</span>
          <div class="timePart bothCenter wft sqr18 brd2">
            <span class="ft12">{{ resetTime.m.toString().padStart(2, '0') }}</span>
          </div>
          <span style="color: #EF773B" class="ml2 mr2">:</span>
          <div class="timePart bothCenter wft sqr18 brd2">
            <span class="ft12">{{ resetTime.s.toString().padStart(2, '0') }}</span>
          </div>
          <span style="color: #EF773B" class="ml2 mr2">:</span>
          <div class="timePart bothCenter wft sqr18 brd2" style="width: 24px">
            <span class="ft12">{{ resetTime.ms }}</span>
          </div>
          <span class="ft12 numberText">&nbsp;内完成支付</span>
        </nut-row>
      </div>
      <nut-row class="bothCenter pd16 box">
        <nut-col :span="16" class="leftCenter numberText">
          <span class="ft18">限时</span>
          <span class="ft16 ml8">¥</span>
          <span class="ft30 ml2">{{ (payOrder.amt / 100).toFixed(2) }}</span>
          <div class="colFlex ml4">
            <span class="ft10" style="text-decoration:line-through">原价¥{{
                (payOrder.originalPrice / 100.0).toFixed(2)
              }}</span>
            <span class="ft10 opd2 wft" style="background: #EF773B">已优惠¥{{ order.discount }}</span>
          </div>
        </nut-col>
        <nut-col :span="8" class="rightCenter">
          <button class="wft ft16 buyBtn vpd8 opd24 brd20" @click="buyNow">立即报名</button>
        </nut-col>
      </nut-row>
      <nut-row class="ft12 bothCenter">
        <nut-checkbox icon-size="12" v-model="agree"/>
        <span>我已阅读并同意</span>
        <a :href="detail.privateInfoProtectAgreement" style="text-decoration: none">
          <span class="numberText">《个人信息授权与保护声明》</span>
        </a>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
import BookMark from "@/components/sale/BookMark";
import {Toast} from "@nutui/nutui";
import api from "@/api";

export default {
  name: "SalePayView",
  components: {BookMark},
  data() {
    return {
      end: Date.now() + 60 * 1000 * 5,
      resetTime: {
        d: '1',
        h: '00',
        m: '00',
        s: '00'
      },
      order: {
        freeHeadCount: 39,
        originalPrice: 99,
        discount: 30,
      },

      timeout: '5分0秒',
      sec: 299,
      ct: null,
      agree: true,
      lessonId: this.$route.params.lessonId,
      detail: {},
      payOrder: {
        amt: 0,
        originalPrice: 0,
      },
      orderId: this.$route.query.orderId,
      orderQueryCnt: 3,
      payUrl: '',
    }
  },
  methods: {
    queryPayOrder() {
      api.getSaleOrder(this.orderId)
          .then(ret => {
            this.payOrder = ret;
            this.payUrl = ret.payUrl;
            if (!ret.paid) {
              if (this.orderQueryCnt-- <= 0) {
                Toast.fail('支付失败!')
                return
              }
              Toast.loading('正在查询支付结果...')
              setTimeout(this.queryPayOrder, 1000)
              return
            }
            Toast.success('支付成功')
            this.afterPaid();
          })
    },
    buyerLimit(skus) {
      let t = 0;
      for (let s of skus) {
        t += s.realBuyerLimit;
      }
      return t;
    },
    buyNow() {
      if (!this.agree) {
        Toast.warn('请先阅读并同意隐私政策')
        return
      }
      Toast.loading('请稍等...')
      window.location.href = this.payUrl;
      // this.afterPaid();
    },
    afterPaid() {
      this.$router.replace('/sale/fill/info/' + this.orderId)
    },
    init() {
      this.ct = setInterval(this.countDown, 1000)
      api.getSaleGood(this.lessonId)
          .then(ret => {
            this.detail = ret.good;
            this.order.originalPrice = '-';
            this.order.discount = (ret.good.couponPrice / 100.0).toFixed(2)
            this.order.freeHeadCount = this.buyerLimit(ret.good.skus) - ret.good.realBuyerCnt;
          })
      if (this.orderId) {
        Toast.loading('正在查询支付结果...')
        this.queryPayOrder();
      }
    },
    countDown() {
      this.timeout = this.secondsToMinutesAndSeconds(this.sec);
      this.sec = this.sec > 0 ? this.sec - 1 : 0;
    },
    secondsToMinutesAndSeconds(seconds) {
      if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) {
        return "无效的输入";
      }
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      if (minutes === 0) {
        return `${remainingSeconds}秒`;
      } else if (remainingSeconds === 0) {
        return `${minutes}分`;
      } else {
        return `${minutes}分${remainingSeconds}秒`;
      }
    },
  },
  mounted() {
    this.init()
  },
  unmounted() {
    if (this.ct) {
      clearInterval(this.ct)
    }
  }
}
</script>

<style lang="scss" scoped>
.SalePayViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;

  .payTime {
    background-image: url("https://cdn.waityou.online/0fee1d68-d2b3-532c-ee20-ea7380429088.png");
    background-size: cover;
    background-position: center;
    height: 240px;
    background-repeat: no-repeat;
  }

  .timePart {
    background: #EF773B;
  }

  .readMark {
    background-image: url("https://cdn.waityou.online/2fc1422d-b720-43da-4ce9-fffd4a4aa0bf.png");
    height: 50px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 9999;
  }

  .bookMarks {
    box-shadow: 0px 2px 8px 1px rgba(230, 230, 230, 0.75);
  }


  .buyBtn {
    border: none;
    background: linear-gradient(0deg, #E05E1D 0%, #EF773B 100%);
  }
}
</style>